import React, { useEffect, useState } from 'react';
import VegaSelect, {
  VegaSelectSelectOptionType,
} from '../../components/common/VegaSelect';
import { useClientAuth } from '../../providers/ClientProvider';
import { fetchBranchList } from '../Program-Dashboard/api/Branch';
import { fetchPlanData } from '../Program-Dashboard/api/PlanPolicies';
import { IOpenCreditCharge } from '../types/plan';

interface IProps {
  selected: any;
  handleChange: (value: any) => void;
  name: string;
}

const OpenCreditChargePlanSelector = ({
  name,
  selected,
  handleChange,
}: IProps) => {
  const { clientId } = useClientAuth();

  const [page, setPage] = useState<number>(0);
  const [totalItem, setTotalItem] = useState<number>(0);
  const [openCreditChargePlan, setOpenCreditChargePlan] = useState<
    VegaSelectSelectOptionType[]
  >([]);

  const loadMoreItems = (event: any) => {
    if (
      event.target.scrollTop + event.target.clientHeight ===
      event.target.scrollHeight
    ) {
      if (totalItem !== openCreditChargePlan.length) {
        setPage(page + 1);
      }
    }
  };

  const getFeePlanList = (policyType: string) => {
    fetchPlanData({ clientId, policyType, page, pageSize: 10 }).then((res) => {
      const planArr = res.data?.records?.map((val: any) => ({
        id: val.policy_id,
        name: val.policy_name,
      }));
      setOpenCreditChargePlan([...openCreditChargePlan, ...planArr]);
      setTotalItem(res.data.totalItems);
    });
  };

  useEffect(() => {
    getFeePlanList('OPEN_CREDIT_CHARGE_PLAN');
  }, [page]);
  return (
    <VegaSelect
      placeholder="Open Credit Charge plan"
      label="Open Credit Charge plan"
      size="small"
      key={name}
      selected={selected ?? ''}
      onChange={(value) => handleChange(value)}
      options={openCreditChargePlan}
      onScroll={loadMoreItems}
    />
  );
};

export default OpenCreditChargePlanSelector;
